import { call } from 'redux-saga/effects';
import { makeRequest } from '../../../core/js/sagas/makeRequest';
import { getProductsRoute } from '../../../core/js/utils/apiRoutes';

/**
 * Makes a call to the catalog service to retrieve product data.
 Data is expected to be passed in as an array of product IDs
 * @param  {Object} state       The current state of the redux store
 * @param  {array} productArray    Array of product ids to look up
 * @param {String} browseCategory Optional. See the product's category in the server side response
 * @return {list} List of products
 */

export function* getProductsByArray(
    state,
    productArray,
    browseCategory,
    queryParam = 'styleNumbers',
    slimProductModel = false,
    excludeOOS = false
) {
    if (_.isArray(productArray) && productArray.length > 0) {
        const route = getProductsRoute(
            state,
            browseCategory,
            productArray,
            queryParam,
            slimProductModel,
            excludeOOS
        );
        return yield call(makeRequest, route);
    }

    return [];
}
